import type { LotDetail, LotListItem } from "@/features/lots/api/types"
import { kgToMt } from "@/lib/format"

export function lotNetMT(lot: LotListItem | LotDetail): number {
  return kgToMt(lot.netKg ?? 0)
}

export function lotUsinageNumber(
  lot: LotListItem | LotDetail,
): string | null {
  return lot.usinage?.usinageNumber ?? null
}
